import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction } from 'features/ui/model/uiSlice';
import { useParams } from 'react-router';
import { DistributionDetail } from 'widgets/user/ui/DistributionDetail';

export const DistributionsDetailPage = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle(`Уведомление №${id}`));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <DistributionDetail />;
};
